import axios from 'axios'
import { FetchProducersQuery } from 'types/producer'
import { stringify } from 'qs'
import { GetParentProducersSlugsResponse } from 'types/bolt-api/request'

/**
 * Get parent producers slugs
 *
 * @param {FetchProducersQuery} query
 * @returns {Promise<Producer | undefined>}
 */
const getParentProducersSlugs = async ({ params }: FetchProducersQuery): Promise<string[]> => {
  try {
    const query = stringify(params, { addQueryPrefix: true, skipNulls: true })
    const { data } = await axios.get<GetParentProducersSlugsResponse>(`${process.env.API_URL}/producers/parents/slugs${query}`, {
      headers: {
        Authorization: `Basic ${process.env.API_TOKEN}`
      }
    })

    return data?.slugs ?? []
  } catch (_) {
    return undefined
  }
}

export default getParentProducersSlugs
